import { useEffect, useState } from "react";
import { RotatingLines } from "react-loader-spinner";
import { Link } from "react-router-dom";
import MainContainer from "../../../components/MainContainer";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { xReqId } from "../../../utils";

const ChooseMinor = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [minors, setMinors] = useState([]);
	const [selectedMinor, setSelectedMinor] = useState(undefined);

	useDocumentTitle("Επιλογή ανηλίκου");

	const handleRadioChange = (event) => {
		const selectedMinorData = minors.find((item) => item.amka === event.target.value);
		setSelectedMinor(selectedMinorData);
	};

	useEffect(() => {
		setLoading(true);

		fetch("/api/tickets/dependents/", {
			credentials: "include",
			headers: {
				"Content-Type": "application/json",
				"x-request-id": xReqId,
			},
		})
			.then((response) => response.json())
			.then((data) => {
				setMinors(data);
				setSelectedMinor(data?.[0]);
				setLoading(false);
			})
			.catch(() => {
				setError(true);
				setLoading(false);
			});
	}, []);

	if (loading) {
		return (
			<MainContainer>
				<div className="col-lg-12 d-flex flex-fill justify-content-center align-items-center">
					<output aria-live="polite" aria-label="Γίνεται φόρτωση των ανηλίκων για επιλογή" className="text-center">
						<span className="visually-hidden">Γίνεται φόρτωση των ανηλίκων για επιλογή.</span>
						<RotatingLines
							visible={true}
							height="96"
							width="96"
							color="grey"
							strokeWidth="5"
							strokeColor="#003476"
							animationDuration="0.75"
							ariaLabel="Γίνεται φόρτωση των ανηλίκων για επιλογή"
						/>
					</output>
				</div>
			</MainContainer>
		);
	}

	const getBody = () => {
		if (error) {
			return (
				<div className="p-4 border bg-body-tertiary border-danger rounded mb-4 col-7">
					<p className="mb-0">Κάτι έχει πάει στραβά. Παρακαλώ δοκιμάστε αργότερα.</p>
				</div>
			);
		}

		if (minors.length === 0) {
			return (
				<div className="p-4 border bg-body-tertiary border-primary rounded mb-4 col-7">
					<p className="mb-0">Δεν βρέθηκαν ανήλικοι για αδειοδότηση σε τρίτο άτομο.</p>
				</div>
			);
		}

		return (
			<>
				<p className="mb-2">Αδειοδότηση συνοδείας ανηλίκου</p>
				<h1 className="mb-4">Επιλογή ανηλίκου</h1>
				<fieldset className="border-0 p-0 m-0">
					<legend className="fs-4 mb-3">Επιλέξτε ανήλικο</legend>
					{minors.map((item) => (
						<div key={item.amka} className="choose-minor-option px-2 py-4 border bg-white border rounded mb-3">
							<label
								className="choose-minor-option-label form-check-label d-flex align-items-center w-100 m-0"
								htmlFor={`flexRadioDefault${item.amka}`}
							>
								<input
									className="form-check-input mt-0 fs-5 mx-2"
									type="radio"
									name="selectedMinor"
									id={`flexRadioDefault${item.amka}`}
									value={item.amka}
									checked={selectedMinor?.amka === item.amka}
									onChange={handleRadioChange}
								/>
								<span className="d-block fw-bold m-lg-0 m-2">
									{item.firstName} {item.lastName} (γεν. {item.birthdate})
								</span>
							</label>
						</div>
					))}
				</fieldset>
				<Link to="/tickets/selected-minor" state={{ selectedMinor }} className="btn btn-primary btn-lg btn-login mt-3">
					Συνέχεια
				</Link>
			</>
		);
	};

	return (
		<MainContainer>
			<div className="col-lg-12">
				<Link to="/tickets/choose-action" className="btn btn-back mb-4">
					<svg focusable="false" viewBox="0 0 24 24" aria-hidden="true">
						<path d="M18,22V2L6,12L18,22z"></path>
					</svg>
					Πίσω
				</Link>
				{getBody()}
			</div>
		</MainContainer>
	);
};
export default ChooseMinor;
